/*eslint-disable*/
import vsbl from 'vsbl'

export default birthdayImage => {
  vsbl(birthdayImage, { threshold: 0.25 })(() => {
    let image = birthdayImage.querySelector('img')
    let imageSrc = image.getAttribute('image-data')
    if (!image.src.includes('/files/')) {
      image.setAttribute('src', imageSrc)
    }
    birthdayImage.classList.add('is-visible')
  })

  $(window).on('load', () => {
    setTimeout(() => {
      let image = birthdayImage.querySelector('img')
      let imageSrc = image.getAttribute('image-data')
      if (!image.src.includes('/files/')) {
        image.setAttribute('src', imageSrc)
      }
      birthdayImage.classList.add('is-visible')
    }, 5000)
  })
}



// WEBPACK FOOTER //
// ./src/scripts/components/birthday-image.js